module.exports = __webpack_public_path__ + "static/img/2.1f6db99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/2.png
// module id = Fs2j
// module chunks = 0